import * as types from '@/store/types'

export default {
    setKeyboard: (context, payload) => {
        payload.struct = payload.struct !== '[]' ? JSON.parse(payload.struct) : [[]]
        payload.bot_id = +payload.bot_id
        const index = context.keyboards.findIndex(item => item.id === payload.id)
        context.keyboards[index] = payload
    },
    addKeyboard: (context, payload) => {
        payload.bot_id = +payload.bot_id
        payload.struct = payload.struct !== '[]' ? JSON.parse(payload.struct) : [[]]
        context.keyboards.push(payload)
    },
    loadKeyboards: (context, payload) => {
        payload.forEach((keyboard, index) => {
            payload[index].struct = payload[index].struct !== '[]' ? JSON.parse(payload[index].struct) : [[]]
        })
        context.keyboards = payload
    },
    removeKeyboard: (context, index) => {
        context.keyboards.splice(index, 1)
    }
}
